import { Environment } from "../types/environment";

export const environment: Environment = {
  production: false,
  type: 'mobile',
  recaptcha: {
    siteKey: '6LeL6fsrAAAAAB3s4ZL0sCbs3r938j6_TYtpXcvQ'
  },
  covenantApiUrl: 'https://apiapp.repas.it/v1/covenant-web',
  geoServicesApiUrl: 'https://apiapp.repas.it/v1/geoservices',
  storesApiUrl: 'https://apiapp.repas.it/v1/stores-web',
  supportApiUrl: 'https://apiapp.repas.it/v1/support'
};

export function backToApp() {
  window.location.href = 'web-link://back';
}

export function callPhone(number: string) {
  window.location.href = `tel:${number}`;
}